// Apollo needs the concrete types to retain fields selected through these interfaces.
export const educationQuestPossibleTypes = {
  EducationQuests_QuestBaseTask: [
    'EducationQuests_QuestChallengeTask',
    'EducationQuests_QuestGameTask',
    'EducationQuests_QuestStoryBuildingTask',
  ],
  EducationQuests_UserTaskBase: [
    'EducationQuests_UserTaskChallenge',
    'EducationQuests_UserTaskGame',
  ],
  EducationQuests_IQuestion: [
    'EducationQuests_MultipleChoiceQuestion',
    'EducationQuests_MissingSectionsOptionsQuestion',
    'EducationQuests_TypingQuestion',
    'EducationQuests_ScrambledQuestion',
    'EducationQuests_MissingPunctuationQuestion',
    'EducationQuests_GroupingQuestion',
    'EducationQuests_TextTargetQuestion',
    'EducationQuests_TextEnhancerQuestion',
    'EducationQuests_MatchingQuestion',
    'EducationQuests_WordContextQuestion',
    'EducationQuests_OrderingQuestion',
    'EducationQuests_ShortWritingQuestion',
    'EducationQuests_AlphabetTracingQuestion',
    'EducationQuests_Explanation',
  ],
}

// Task IDs come from quest templates and are shared by different children.
export const educationQuestTypePolicies = {
  EducationQuests_UserTaskChallenge: { keyFields: false as const },
  EducationQuests_UserTaskGame: { keyFields: false as const },
}
